<template>
    <f7-page
        name="Comment"
        messages-content
    >
        <f7-navbar
            :title-large="unit.name ? 'Discuss' : 'Comments'"
            large
        >
            <f7-nav-left>
                <f7-link
                    v-if="fromHome"
                    href="#"
                    style="padding: 0 16px 0;"
                    aria-label="Bookmark"
                    @click="bookmark"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 17 18"
                    >
                        <polygon
                            :fill="unit.bookmarked ? (darkTheme ? '#fff' : '#000') : 'none'"
                            :stroke="darkTheme ? 'white' : 'black'"
                            stroke-width="1"
                            points="18 29 18 13 33.048 13 33.048 29 25.524 23.245"
                            transform="translate(-17 -12)"
                        />
                    </svg>
                </f7-link>
                <f7-link
                    v-else
                    @click="backCloseIfLast"
                >
                    <i
                        :class="`icon ion-ios-arrow-back`"
                        style="padding: 0 16px 0;"
                    />
                </f7-link>
            </f7-nav-left>
            <f7-nav-title>{{ unit.name || 'Comments' }}</f7-nav-title>
            <f7-nav-right>
                <f7-link
                    aria-label="Share"
                    @click="share"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                    >
                        <g
                            :stroke="darkTheme ? 'white' : 'black'"
                            fill="none"
                            fill-rule="evenodd"
                            stroke-width="1"
                            transform="translate(1 1)"
                        >
                            <polyline points="0 9.49 0 15.169 13.65 15.169 13.65 9.49" />
                            <path
                                stroke-linecap="square"
                                d="M6.95454545,10.2626904 L6.95454545,0.989963089"
                            />
                            <path
                                d="M5.0225982,-1.71445329 L8.81973527,2.08268378 C8.90874519,2.1716937 8.90874519,2.31598202 8.81973527,2.40499194 L5.21190777,6.01281944"
                                transform="rotate(-90 6.955 2.15)"
                            />
                        </g>
                    </svg>
                </f7-link>
                <f7-link
                    v-if="fromHome"
                    href="#"
                    style="padding: 0 10px 0; "
                    @click="backCloseIfLast"
                >
                    <i
                        class="icon ion-close-round"
                        style="font-size: 20px;"
                    />
                </f7-link>
                <f7-link
                    v-else
                    href="#"
                    style="padding: 0 16px 0;"
                    @click="bookmark"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 17 18"
                    >
                        <polygon
                            :fill="unit.bookmarked ? (darkTheme ? '#fff' : '#000') : 'none'"
                            :stroke="darkTheme ? 'white' : 'black'"
                            stroke-width="1"
                            points="18 29 18 13 33.048 13 33.048 29 25.524 23.245"
                            transform="translate(-17 -12)"
                        />
                    </svg>
                </f7-link>
            </f7-nav-right>
        </f7-navbar>

        <f7-messages
            ref="messages"
            :scroll-messages="false"
            :scroll-messages-on-edge="true"
        >
            <f7-messages-title
                v-if="unit.name || unit.description"
                class="description">
                <h1 v-if="unit.name">{{ unit.name }}</h1>
                {{ unit.description }}<br><br>
            </f7-messages-title>

            <f7-messages-title v-if="loaded && messagesData.length === 0">
                <br><br>No comments yet.<br><br>Be the first!
            </f7-messages-title>

            <f7-message
                v-for="(message, index) in messagesData"
                :key="index"
                :type="message.userId === user.id ? 'sent' : 'received'"
                :image="message.image"
                :avatar="message.avatar"
                :first="isFirstMessage(message, index)"
                :last="isLastMessage(message, index)"
                :tail="isTailMessage(message, index)"
            >
                <div slot="name">
                    <span v-if="!(message.user.forumTitle && message.user.forumTitle.toLowerCase()=='expert')">{{ message.name }}</span>
                    <span v-if="message.user.forumTitle && message.user.forumTitle.toLowerCase()=='expert'">
                       <a :href="`https://getcoral.app/about#${message.name || 'expert_' + message.user.id}`" :onclick="`window.location.href='https://getcoral.app/about#${message.name || 'expert_' + message.user.id}'`">{{ message.name }}</a>
                    </span>
                    <span
                        v-if="message.user.forumTitle"
                        class="forumTitle"
                    >- {{ message.user.forumTitle }}</span>
                    <span
                        v-if="user.isAdmin"
                        v-html="formatDate(message.createdAt)"
                    />
                </div>
                <div
                    slot="text"
                    class="selectable"
                    v-html="message.text"
                />
                <div
                    slot="bubble-end"
                    class="message-footer"
                >
                    <a
                        href="#"
                        @click="message.userId !== user.id ? doLike(message) : () => {}"
                    >UpVote{{ message.liked ? 'd' : '' }}({{ message.likesTotal }})</a>

                    <a :href="`/replies/${message.id}`">Replies({{ message.repliesTotal }})</a>
                    <a
                        href="#"
                        class="more"
                        @click="more(message)"
                    ><i class="ion ion-more" /></a>
                </div>
            </f7-message>
            <br><br>
            <template v-if="showLoadMore">
                <f7-link @click="getComments(true)">Load more comments</f7-link>
                <br><br>
            </template>
        </f7-messages>
        <f7-messagebar
            ref="messagebar"
            :placeholder="'Add a comment...'"
            :attachments-visible="mentionIsOpen"
            class="messagebar"
            @input="textChange"
        >
            <f7-messagebar-attachments>
                <div style="height: 100px">
                    <div
                        v-for="(username, index) in mentionUsers"
                        :key="index"
                        class="mentionItem"
                        @click="addAsMention(username)"
                    >@{{ username }}</div>
                </div>
            </f7-messagebar-attachments>
            <f7-link
                slot="inner-end"
                icon="ion-ios-arrow-thin-right"
                class="largeIcon"
                @click="sendMessage"
            />
        </f7-messagebar>
    </f7-page>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

import utils from '../../js/utils';

export default {
    store: ['api', 'user', 'topicsIndex', 'coursesIndex', 'unitsIndex', 'darkTheme', 'partners'],
    data () {
        return {
            scrollLoaded: false,
            loaded: false,
            comment: {
                id: 0,
                text: '',
            },
            unit: {
                id: 0,
                name: '',
                type: '',
                description: '',
                bookmarked: false,
            },
            fromHome: false,
            currentId: 0,
            comments: [],
            messagesData: [],
            mentionIsOpen: false,
            mentionUsers: [],
            mentionedUsers: [],
            showLoadMore: false,
        };
    },
    computed: {},
    created: function () {
     },
    mounted: function () {
        const loadData = () => {
            setTimeout(() => {
                this.getComments();
                this.deepLinkProposal();
            }, 400);

            if (this.unitsIndex[this.currentId]) {
                this.unit = this.unitsIndex[this.currentId];

                document.title = this.unit ? this.unit.name : document.title;
            } else {
                this.getUnit();
            }
        };

        this.$f7ready(() => {
            this.messagebar = this.$refs.messagebar.f7Messagebar;
            this.messages = this.$refs.messages.f7Messages;
        });

        if (this.$f7route.query.home) {
            this.fromHome = true;
        }

        if (this.$f7route.params.id) {
            if (/^\d+$/.test(this.$f7route.params.id)) {
                this.currentId = this.$f7route.params.id;
                loadData();
            } else {
                this.$http.get(`${this.api}/get-unit-id/${this.$f7route.params.id}`).then(
                 response => {
                        this.currentId = response.body;
                        loadData();
                    }
                );
            }
        }
    },
    methods: {
        deepLinkProposal: function() {
            try {
                if (utils.isMobile()) {
                    const ua = navigator.userAgent.toLowerCase();
	                const isAndroid = ua.indexOf("android") > -1;
                    const link = `/units/${this.currentId}`;
		            if (isAndroid) {
                        let url ="coral:///";
			            if (/Chrome/i.test(ua)) url = `intent://${link}/#Intent;scheme=coral;package=app.getcoral.m;end"`
                        window.location.replace(url);
		            } else {
			            window.location.href = `coral://${link}`;
		            }
	            }
            } catch (e) {
                alert(`Can't redirect to Coral Application.`);
            }
        },
        textChange: function (e) {
            if (e.data === '@' && !this.mentionIsOpen) {
                this.mentionIsOpen = true;
            }
            if (e.data === ' ' && this.mentionIsOpen) {
                this.mentionIsOpen = false;
            }
            if (e.data === null && this.mentionIsOpen) {
                //  backspace
                this.mentionIsOpen = false;
            }
            if (e.target.value.length === 0) this.mentionIsOpen = false;
            if (this.mentionIsOpen && e.data !== '@') {
                var caratPos = this.messagebar.textareaEl.selectionStart,
                    tmpStr = this.messagebar.getValue(),
                    i;
                for (i = caratPos; i >= 0; i--) {
                    if (tmpStr[i] == '@') {
                        break;
                    }
                }


                var searchTerm = tmpStr.substring(caratPos, i + 1);
                // reset to context mention users
                this.resetMentionUsers();
                if (searchTerm.length > 0) {
                    // OneVoice code this.findMentions(searchTerm);
                    this.mentionUsers = _.filter(this.mentionUsers, function (item) {
                        return _.startsWith(item, searchTerm);
                    });
                }
            }
        },
        resetMentionUsers: function () {
            this.mentionUsers = [];
            for (let i = 0; i < this.partners.length; i++) {
                const p = this.partners[i];
                if (this.mentionUsers.indexOf(p.username) === -1 && p.username !== 'etienne')
                    this.mentionUsers.push(p.username);
            }
            for (let i = 0; i < this.messagesData.length; i++) {
                const comment = this.messagesData[i];
                if (this.mentionUsers.indexOf(comment.user.username) === -1 && comment.user.username !== 'etienne')
                    this.mentionUsers.push(comment.user.username);
            }
        },
        addAsMention: function (username) {
            this.mentionedUsers.push(username);
            var caratPos = this.messagebar.textareaEl.selectionStart,
                tmpStr = this.messagebar.getValue(),
                i;
            for (i = caratPos; i >= 0; i--) {
                if (tmpStr[i] == '@') {
                    break;
                }
            }
            tmpStr.substring(i, caratPos)
            var textBefore = tmpStr.substring(0, i),
                textAfter = tmpStr.substring(caratPos),
                newStr = textBefore + '@' + username + textAfter;

            // insert:
            this.messagebar.setValue(newStr);

            // move cursor:
            setTimeout(() => {
                caratPos += username.length;
                this.messagebar.textareaEl.selectionStart = this.messagebar.textareaEl.selectionEnd = caratPos;
                this.mentionIsOpen = false;
                this.messagebar.focus();
            }, 10);
        },
        more: function (message) {
            const buttons = [];
            if (message.userId === this.user.id) {
                buttons.push({
                    text: 'Delete',
                    color: 'red',
                    onClick: () => {
                        this.doDelete(message)
                    }
                });
            } else {

                buttons.push({
                    text: 'Flag as inappropriate',
                    onClick: () => {
                        this.doFlag(message);
                    }
                });
            }

            f7.actions
                .create({
                    title: 'Comment options',
                    buttons: [buttons, [{
                        text: 'Cancel',
                        onClick: () => {

                        }
                    }]]
                })
                .open();
        },
        share: function () {
            this.$events.fire('trackEvent', 'share', 'share', this.unit.id, this.unit.name);
            // f7.dialog.alert('Sharing is disabled during the private BETA.');
            utils.shareModule(
                `"${this.unit.name}" on Coral: Horizontal happiness`,
                this.unit.description,
                `/units/${this.unit.id}`,
                'unit',
                this.user.id
            );
        },
        backCloseIfLast: function () {
            if (this.unit && this.unit.type === 'question' && !this.unit.completed) {
                this.$events.fire('user-progress', {
                    itemId: this.unit.isVersionOf || this.unit.id,
                    courseId: this.unit.courseId,
                    topicId: this.coursesIndex[this.unit.courseId] ? this.coursesIndex[this.unit.courseId].topicId : 0,
                    type: 'unit',
                    progress: 100,
                    completed: true,
                    item: this.unit,
                });
                this.unit.completed = true;
                Vue.set(this.unit, 'completed', true);
                this.$events.fire(`unit-completed-${this.unit.isVersionOf || this.unit.id}`);
            }
            // console.log(f7.views['popup'].router.history.length)
            if (this.$f7router.view.main) {
                // console.log('Is on main router');
                if (f7.views['main'].router.history.length === 1) {
                    f7.views['main'].router.navigate('/home', { clearPreviousHistory: true });
                }
            } else {
                if (this.$f7router.view.router.history.length === 1) {
                    if (f7.popup.get(`#${this.$f7router.view.name}`)) {
                        f7.popup.get(`#${this.$f7router.view.name}`).open();
                        f7.popup.get(`#${this.$f7router.view.name}`).close();
                    }
                    return
                }
                this.$f7router.view.router.back();
            }
        },
        bookmark: function () {
            let send = {
                unitId: this.unit.id,
                slideId: 0
            };
            if (this.unit.bookmarked) {
                send = {
                    body: send
                };
            }
            this.$http[this.unit.bookmarked ? 'delete' : 'post'](
                `${this.api}/bookmarks`,
                send
            ).then(() => { }, () => {

            });
            this.unit.bookmarked = !this.unit.bookmarked;
        },
        renderSubtitle: function () {
            return this.renderUnitType(this.unit.type);
        },
        renderUnitType: function (type) {
            return utils.renderUnitType(type);
        },
        formatDate: function (date) {
            return moment(date).utc().fromNow();
        },
        doDelete: function (comment) {
            if (comment.userId !== this.user.id) return;
            this.$http['delete'](`${this.api}/comments/${comment.id}`);
            for (let i = 0; i < this.messagesData.length; i++) {
                const element = this.messagesData[i];
                if (element.id === comment.id) {
                    this.messagesData.splice(i, 1);
                    break;
                }
            }
        },
        doFlag: function (comment) {
            if (comment.userId === this.user.id) return;
            this.$http['post'](`${this.api}/comments/${comment.id}/flag`);
            for (let i = 0; i < this.messagesData.length; i++) {
                const element = this.messagesData[i];
                if (element.id === comment.id) {
                    this.messagesData.splice(i, 1);
                    break;
                }
            }
            f7.dialog.alert('This comment has been removed for the moment and is being reviewed by our team. If it violates our terms and conditions it will be permanently deleted.', 'Thanks for flagging this!');
        },
        doLike: function (message) {
            if (message.userId === this.user.id) return;
            message.liked = !message.liked;
            if (message.liked) {
                message.likesTotal++;
            } else {
                message.likesTotal--;
            }
            this.$http[message.liked ? 'post' : 'delete'](`${this.api}/comments/${message.id}/like`).then(() => { }, () => { });
        },
        getComments: function (append) {
            this.showLoadMore = false;
            this.$http.get(`${this.api}/units/${this.currentId}/comments?offset=${append ? this.messagesData.length : 0}`).then(
                response => {
                    if (response.body.length > 0) {
                        if (append) {
                            this.messagesData = this.messagesData.concat(this.renderComments(response.body));
                        } else {
                            this.messagesData = this.renderComments(response.body);
                        }
                        this.resetMentionUsers();
                        if (response.body.length === 20) {
                            this.showLoadMore = true;
                        }
                    }
                    setTimeout(() => {
                        this.loaded = true;
                    }, 10);
                },
                () => {
                    this.messagesData = [];
                }
            );
        },
        getUnit: function () {
            this.$http.get(`${this.api}/units/${this.currentId}`).then(
                response => {
                    this.unit = response.body;

                    document.title = this.unit ? this.unit.name : document.title;
                },
                () => { }
            );
        },
        renderComments: function (comments) {
            for (let i = 0; i < comments.length; i++) {
                const comment = comments[i];
                comment.name = comment.user.username;
                if (comment.user.id === 15) comment.name = comment.username;
                if (comment.answer) {
                    // console.log(comment.answer, this.question.answers);
                    if (this.question.type === 'multi') {
                        comment.color = this.question.answers[comment.answer.choiceInt].color;
                    } else if (this.question.type === 'stars') {
                        comment.color = 'yellow';
                    } else if (this.question.type === 'number') {
                        comment.color = 'blue';
                    }
                }
            }
            return comments;
        },
        isFirstMessage: function (message, index) {
            const previousMessage = this.messagesData[index - 1];
            if (message.isTitle) return false;
            if (!previousMessage || previousMessage.type !== message.type || previousMessage.name !== message.name)
                return true;
            return false;
        },
        isLastMessage (message, index) {
            const nextMessage = this.messagesData[index + 1];
            if (message.isTitle) return false;
            if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
            return false;
        },
        isTailMessage (message, index) {
            const nextMessage = this.messagesData[index + 1];
            if (message.isTitle) return false;
            if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name) return true;
            return false;
        },
        sendMessage: function () {
            if (!this.user.username) {
                this.$f7router.view.router.navigate(`/username?view=${this.$f7router.view.name}`);
                return;
            }
            this.messages.scroll();
            const text = this.messagebar
                .getValue()
                .replace(/\n/g, '<br>')
                .trim();
            if (text.length === 0) {
                // exit when empty messagebar text is empty
                return;
            }
            // Clear messagebar area
            this.messagebar.clear();
            // Focus area
            if (text.length) this.messagebar.focus();
            // Add sent message

            this.$http
                .post(`${this.api}/units/${this.currentId}/comments`, {
                    text,
                    unitId: this.currentId,
                    parentId: 0,
                })
                .then((response) => {
                    this.$events.fire('trackEvent', `commented`, 'actions', this.currentId, this.unit.name);
                    this.messagesData.push(
                        this.renderComments([
                            response.body,
                        ])[0]
                    );
                    setTimeout(() => {
                        this.messages.scroll();
                    }, 100);
                }, () => { });
            // // Mock response
            // return
            // if (this.responseInProgress) return;
            // this.responseInProgress = true;
            // setTimeout(() => {
            //     this.messages.showTyping({
            //         header: `Eti is typing`,
            //     });
            //     setTimeout(() => {
            //         this.messagesData.push({
            //             text: 'Hiii!',
            //             type: 'received',
            //             name: 'Eti',
            //         });
            //         this.messages.hideTyping();
            //         this.responseInProgress = false;
            //     }, 4000);
            // }, 1000);
        },
        onF7Ready () {
            // References to us APIs
            this.messagebar = this.$refs.messagebar.f7Messagebar;
            this.messages = this.$refs.messages.f7Messages;
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.comment {
    padding: 6px 20px 0 0;
    position: relative;
}
.description {
    font-family: Editor-Light;
    font-size: 16px;
    color: @darkGray;
    text-align: center;
    line-height: 26px;
    padding: 0 16px;
}
.theme-dark {
    .description {
        color: white;
    }
}
.like {
    position: absolute;
    top: -4px;
    right: -10px;
    padding: 10px;
    i {
        font-size: 20px;
        color: @black;
    }
}
.title {
    font-weight: bold;
    font-size: 15px;
    line-height: 14px;
}
.text {
    font-size: 15px;
    line-height: 14px;
}
.after {
    font-size: 15px;
    line-height: 14px;
    font-weight: bold;
}
.replies.link {
    color: black;
    font-size: 14px;
    font-weight: bold;
    padding-bottom: 6px;
}
.largeIcon {
    font-size: 40px;
}
.more {
    padding: 0 14px 0 10px;
    i.ion {
        line-height: 12px;
        font-size: 15px;
    }
}
.mentionItem {
    height: 27px;
    color: black;
    line-height: 20px;
    font-size: 13px;
    padding: 0px;
    margin: 0px;
}
.forumTitle {
    color: #fc6f65;
    letter-spacing: -0.1px;
}
</style>
